/** Estado derivado de una entrada del historial de reportes. */
export function getReportHistoryStatus(item) {
  if (!item) return { label: 'Desconocido', color: 'default' };
  if (item.error && !item.fileName) return { label: 'Error', color: 'error' };
  if (item.error) return { label: 'Advertencia', color: 'warning' };
  return { label: 'Exitoso', color: 'success' };
}

const EMAIL_PROBLEM_LABEL = {
  not_configured:
    'El correo no se envió: falta configurar AWS SES en Admin → Reportes (clave, secreto y remitente).',
  no_recipients: 'El correo no se envió: el reporte no tiene destinatarios.',
};

export function getReportHistoryStatusDescription(item) {
  if (!item?.error) return null;
  const emailLabel = EMAIL_PROBLEM_LABEL[item.error];
  if (item.fileName && emailLabel) {
    return `PDF generado. ${emailLabel}`;
  }
  if (item.fileName) {
    return `PDF generado, pero hubo un problema: ${item.error}`;
  }
  return emailLabel || item.error;
}
